document.documentElement.classList.remove('no-js');

function formatMoney(cents) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(cents / 100);
  } catch (error) {
    return (cents / 100).toFixed(2);
  }
}

function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

const cartDrawer = document.querySelector('#CartDrawer');
const drawerScrim = document.querySelector('.drawer-scrim');

function setCartDrawer(open) {
  if (!cartDrawer) return;

  cartDrawer.classList.toggle('open', open);
  cartDrawer.setAttribute('aria-hidden', String(!open));

  if (drawerScrim) {
    drawerScrim.classList.toggle('open', open);
  }

  document.body.style.overflow = open ? 'hidden' : '';
}

async function refreshCartDrawer() {
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${root}cart.js`);

  if (!response.ok) {
    throw new Error('Unable to load cart');
  }

  const cart = await response.json();

  document.querySelectorAll('[data-cart-count]').forEach((element) => {
    element.textContent = cart.item_count;
  });

  const target = document.querySelector('[data-cart-drawer-content]');
  if (!target) return;

  if (cart.item_count === 0) {
    target.innerHTML = '<p>Your cart is currently empty.</p>';
    return;
  }

  const items = cart.items.map((item) => {
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="">`
      : '';

    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p>${escapeHtml(item.variant_title)}</p>`
      : '';

    return `
      <article class="drawer-item" data-cart-key="${escapeHtml(item.key)}">
        ${image}
        <div class="drawer-item-info">
          <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${variant}
          <div class="drawer-controls">
            <div class="drawer-quantity" aria-label="Quantity">
              <button type="button" data-cart-decrease aria-label="Decrease quantity">−</button>
              <input type="number" min="1" value="${item.quantity}" data-cart-quantity aria-label="Quantity for ${escapeHtml(item.product_title)}">
              <button type="button" data-cart-increase aria-label="Increase quantity">+</button>
            </div>
            <button class="drawer-remove" type="button" data-cart-remove>Remove</button>
          </div>
          <strong>${formatMoney(item.final_line_price)}</strong>
        </div>
      </article>
    `;
  }).join('');

  target.innerHTML = `
    ${items}
    <div class="drawer-total">
      <span>Subtotal</span>
      <strong>${formatMoney(cart.total_price)}</strong>
    </div>
    <a class="button" href="${root}cart">View shopping cart</a>
  `;
}

async function changeCartItem(key, quantity) {
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${root}cart/change.js`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id: key, quantity })
  });

  if (!response.ok) {
    throw new Error('Unable to update cart');
  }

  await refreshCartDrawer();
}

const pendingCartChanges = new Map();

function scheduleCartItemChange(item, key, quantity, delay = 220) {
  const existing = pendingCartChanges.get(key);
  if (existing?.timer) window.clearTimeout(existing.timer);

  item.classList.add('is-pending');
  const timer = window.setTimeout(async () => {
    try {
      await changeCartItem(key, quantity);
    } catch (error) {
      try {
        await refreshCartDrawer();
      } catch (refreshError) {
        item.classList.remove('is-pending');
      }
    } finally {
      pendingCartChanges.delete(key);
    }
  }, delay);

  pendingCartChanges.set(key, { timer, quantity });
}

cartDrawer?.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-decrease], [data-cart-increase], [data-cart-remove]');
  if (!button) return;

  const item = button.closest('[data-cart-key]');
  const input = item?.querySelector('[data-cart-quantity]');
  if (!item || !input) return;

  const currentQuantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
  const nextQuantity = button.hasAttribute('data-cart-remove')
    ? 0
    : button.hasAttribute('data-cart-increase')
      ? currentQuantity + 1
      : Math.max(0, currentQuantity - 1);

  if (nextQuantity === 0) {
    item.style.opacity = '.45';
    scheduleCartItemChange(item, item.dataset.cartKey, 0, 0);
    return;
  }

  input.value = nextQuantity;
  scheduleCartItemChange(item, item.dataset.cartKey, nextQuantity);
});

cartDrawer?.addEventListener('change', (event) => {
  const input = event.target.closest('[data-cart-quantity]');
  if (!input) return;

  const item = input.closest('[data-cart-key]');
  if (!item) return;

  const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
  input.value = quantity;
  scheduleCartItemChange(item, item.dataset.cartKey, quantity);
});

document.querySelector('.cart-toggle')?.addEventListener('click', async () => {
  try {
    await refreshCartDrawer();
  } catch (error) {
    // Keep the server-rendered cart available if the refresh request fails.
  }
  setCartDrawer(true);
});

document.querySelector('.cart-close')?.addEventListener('click', () => {
  setCartDrawer(false);
});

drawerScrim?.addEventListener('click', () => {
  setCartDrawer(false);
});

const searchModal = document.querySelector('#SearchModal');

function setSearchModal(open) {
  if (!searchModal) return;

  searchModal.classList.toggle('open', open);
  searchModal.setAttribute('aria-hidden', String(!open));
  document.body.style.overflow = open ? 'hidden' : '';

  if (open) {
    window.setTimeout(() => {
      searchModal.querySelector('input')?.focus();
    }, 50);
  }
}

document.querySelector('.search-toggle')?.addEventListener('click', () => {
  setSearchModal(true);
});

document.querySelector('.search-close')?.addEventListener('click', () => {
  setSearchModal(false);
});

searchModal?.addEventListener('click', (event) => {
  if (event.target === searchModal) {
    setSearchModal(false);
  }
});

document.querySelectorAll('.header-search').forEach((searchDisclosure) => {
  document.addEventListener('pointerdown', (event) => {
    if (searchDisclosure.open && !searchDisclosure.contains(event.target)) {
      searchDisclosure.removeAttribute('open');
    }
  });
});

function initializeDesktopNavigation() {
  document.querySelectorAll('.desktop-nav > .nav-item').forEach((navItem) => {
    if (navItem.dataset.navigationBound === 'true') return;
    navItem.dataset.navigationBound = 'true';

    const dropdown = navItem.querySelector('.nav-dropdown');
    if (!dropdown) return;

    const rows = [...dropdown.querySelectorAll('.nav-subitem')];
    const panels = [...dropdown.querySelectorAll('.nav-submenu')];
    let activeRow = null;

    const updateViewportHeight = () => {
      if (dropdown.getClientRects().length === 0) return;
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const availableHeight = Math.max(80, viewportHeight - dropdown.getBoundingClientRect().top - 12);
      dropdown.style.setProperty('--nav-available-height', `${availableHeight}px`);
    };

    const activateRow = (row) => {
      const panelId = row?.dataset.navPanel;
      activeRow = panelId ? row : null;
      dropdown.classList.toggle('has-active-submenu', Boolean(panelId));

      rows.forEach((candidate) => {
        const active = candidate === activeRow;
        candidate.classList.toggle('is-active', active);
        candidate.querySelector('a[aria-expanded]')?.setAttribute('aria-expanded', String(active));
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== panelId; });
      updateViewportHeight();
    };

    navItem.addEventListener('pointerenter', () => {
      navItem.classList.remove('is-dismissed');
      updateViewportHeight();
    });
    navItem.addEventListener('pointerleave', () => {
      if (!navItem.contains(document.activeElement)) activateRow(null);
    });
    navItem.addEventListener('focusin', (event) => {
      navItem.classList.remove('is-dismissed');
      const row = event.target.closest('.nav-subitem');
      if (row) activateRow(row);
      updateViewportHeight();
    });
    navItem.addEventListener('focusout', (event) => {
      if (!navItem.contains(event.relatedTarget) && !navItem.matches(':hover')) activateRow(null);
    });

    rows.forEach((row) => {
      row.addEventListener('pointerenter', () => activateRow(row));
      row.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' || !row.dataset.navPanel) return;
        event.preventDefault();
        activateRow(row);
        panels.find((panel) => panel.id === row.dataset.navPanel)?.querySelector('a')?.focus();
      });
    });
    panels.forEach((panel) => {
      panel.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' || !activeRow) return;
        event.preventDefault();
        const originLink = activeRow.querySelector('a');
        originLink?.focus();
        activateRow(null);
      });
    });
    navItem.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      navItem.querySelector(':scope > a')?.focus();
      activateRow(null);
      navItem.classList.add('is-dismissed');
    });
    navItem.addEventListener('navigation:close', () => {
      activateRow(null);
      navItem.classList.add('is-dismissed');
    });

    window.addEventListener('resize', updateViewportHeight, { passive: true });
    window.addEventListener('scroll', updateViewportHeight, { passive: true });
  });
}

initializeDesktopNavigation();
document.addEventListener('shopify:section:load', initializeDesktopNavigation);

const backToTopButton = document.querySelector('.back-to-top');

window.addEventListener('scroll', () => {
  backToTopButton?.classList.toggle('show', window.scrollY > 500);
}, { passive: true });

backToTopButton?.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.querySelectorAll('[data-process-tab]').forEach((button) => {
  if (button.dataset.storyBound === 'true') return;
  button.dataset.storyBound = 'true';
  button.addEventListener('click', () => {
    document.querySelectorAll('[data-process-tab]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('active', active);
      item.setAttribute('aria-selected', String(active));
    });

    document.querySelectorAll('[data-process-panel]').forEach((panel) => {
      const active = panel.dataset.processPanel === button.dataset.processTab;
      panel.classList.toggle('active', active);
      panel.hidden = !active;
    });
  });
});

document.querySelectorAll('[data-felt-tab]').forEach((button) => {
  if (button.dataset.storyBound === 'true') return;
  button.dataset.storyBound = 'true';
  button.addEventListener('click', () => {
    document.querySelectorAll('[data-felt-tab]').forEach((item) => {
      item.classList.toggle('active', item === button);
    });

    document.querySelectorAll('[data-felt-panel]').forEach((panel) => {
      const active = panel.dataset.feltPanel === button.dataset.feltTab;
      panel.classList.toggle('active', active);
      panel.hidden = !active;
    });
  });
});

document.querySelectorAll('.product-form').forEach((form) => {
  const variantSelect = form.querySelector('.variant-select');
  const optionInputs = [...form.querySelectorAll('.product-option input[type="radio"]')];
  const optionGroups = [...form.querySelectorAll('.product-option')];
  const submitButton = form.querySelector('.add-to-cart');
  const priceElement = document.querySelector('[data-product-price]');

  function variantValues(option) {
    try {
      return JSON.parse(option.dataset.options || '[]');
    } catch (error) {
      return [];
    }
  }

  function availableVariants() {
    return variantSelect
      ? [...variantSelect.options].filter((option) => option.dataset.available === 'true')
      : [];
  }

  function updateOptionAvailability() {
    const variants = availableVariants();

    optionGroups.forEach((group, groupIndex) => {
      const priorSelections = optionGroups.slice(0, groupIndex).map((priorGroup) => {
        return priorGroup.querySelector('input:checked')?.value;
      });

      [...group.querySelectorAll('input[type="radio"]')].forEach((input) => {
        const possible = variants.some((variant) => {
          const values = variantValues(variant);
          return values[groupIndex] === input.value
            && priorSelections.every((value, index) => !value || values[index] === value);
        });

        input.disabled = !possible;
        input.closest('label')?.classList.toggle('option-unavailable', !possible);
      });

      const selected = group.querySelector('input:checked');
      if (!selected || selected.disabled) {
        const firstAvailable = group.querySelector('input:not(:disabled)');
        if (firstAvailable) firstAvailable.checked = true;
      }
    });
  }

  function updateSelectedVariant() {
    if (!variantSelect) return;

    updateOptionAvailability();

    const selectedValues = optionInputs
      .filter((input) => input.checked)
      .map((input) => input.value);

    const matchingOption = [...variantSelect.options].find((option) => {
      try {
        const values = variantValues(option);
        return values.length === selectedValues.length
          && values.every((value, index) => value === selectedValues[index]);
      } catch (error) {
        return selectedValues.every((value) => option.textContent.includes(value));
      }
    });

    if (!matchingOption) return;

    variantSelect.value = matchingOption.value;

    const gallery = document.querySelector('[data-product-gallery]');
    if (gallery && (matchingOption.dataset.imageId || matchingOption.dataset.imageSrc)) {
      gallery.dispatchEvent(new CustomEvent('variant:image-change', {
        detail: {
          imageId: matchingOption.dataset.imageId,
          imageSrc: matchingOption.dataset.imageSrc,
          imageAlt: matchingOption.dataset.imageAlt
        }
      }));
    }

    const productUrl = new URL(window.location.href);
    productUrl.searchParams.set('variant', matchingOption.value);
    window.history.replaceState({}, '', productUrl);

    if (priceElement && matchingOption.dataset.price) {
      const price = matchingOption.dataset.price;
      const compareAtPrice = matchingOption.dataset.compareAtPrice;
      const priceCents = Number.parseInt(matchingOption.dataset.priceCents, 10) || 0;
      const compareAtPriceCents = Number.parseInt(matchingOption.dataset.compareAtPriceCents, 10) || 0;

      priceElement.innerHTML = compareAtPriceCents > priceCents
        ? `<span class="price-display price-display--sale"><span class="price-sale">${escapeHtml(price)}</span><s class="price-compare">${escapeHtml(compareAtPrice)}</s></span>`
        : `<span class="price-display"><span class="price-regular">${escapeHtml(price)}</span></span>`;
    }

    if (submitButton) {
      const available = matchingOption.dataset.available === 'true';
      submitButton.disabled = !available;
      submitButton.textContent = available ? 'Add to bag' : 'Sold out';
    }
  }

  optionInputs.forEach((input) => {
    input.addEventListener('change', updateSelectedVariant);
  });

  updateSelectedVariant();

  form.addEventListener('submit', async (event) => {
    if (!cartDrawer) return;

    event.preventDefault();

    if (submitButton) {
      submitButton.disabled = true;
    }

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) {
        throw new Error('Unable to add product');
      }

      await refreshCartDrawer();
      setCartDrawer(true);
    } catch (error) {
      if (submitButton) {
        submitButton.textContent = 'Unable to add';
      }
    } finally {
      if (submitButton && submitButton.textContent !== 'Sold out') {
        submitButton.disabled = false;
      }
    }
  });
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const mainImage = gallery.querySelector('[data-gallery-main]');
  const thumbnails = [...gallery.querySelectorAll('[data-gallery-index]')];
  const previousButton = gallery.querySelector('.gallery-prev');
  const nextButton = gallery.querySelector('.gallery-next');
  const zoomButton = gallery.querySelector('.gallery-zoom');
  const lightbox = gallery.querySelector('.gallery-lightbox');
  const lightboxImage = lightbox?.querySelector('img');
  const closeButton = gallery.querySelector('.gallery-lightbox-close');
  const lightboxPreviousButton = gallery.querySelector('.gallery-lightbox-prev');
  const lightboxNextButton = gallery.querySelector('.gallery-lightbox-next');
  const stage = gallery.querySelector('.gallery-stage');
  const lens = gallery.querySelector('.gallery-lens');

  let currentIndex = 0;
  let lightboxScale = 1;
  let lightboxX = 0;
  let lightboxY = 0;
  let dragStartX = 0;
  let dragStartY = 0;
  let dragOriginX = 0;
  let dragOriginY = 0;
  let draggingLightbox = false;

  if (lightbox) document.body.appendChild(lightbox);
  if (lens) document.body.appendChild(lens);

  function applyLightboxTransform() {
    if (!lightboxImage) return;
    lightboxImage.style.transform = `translate3d(${lightboxX}px, ${lightboxY}px, 0) scale(${lightboxScale})`;
    lightbox?.classList.toggle('is-zoomed', lightboxScale > 1);
  }

  function resetLightboxZoom() {
    lightboxScale = 1;
    lightboxX = 0;
    lightboxY = 0;
    draggingLightbox = false;
    if (lightboxImage) {
      applyLightboxTransform();
      lightboxImage.style.cursor = 'zoom-in';
    }
    lightbox?.classList.remove('is-dragging');
  }

  function showImage(nextIndex) {
    if (!mainImage || thumbnails.length === 0) return;

    currentIndex = (nextIndex + thumbnails.length) % thumbnails.length;
    const selectedThumbnail = thumbnails[currentIndex];
    const imageSource = selectedThumbnail.dataset.gallerySrc;
    const imageAlt = selectedThumbnail.dataset.galleryAlt || '';

    if (!imageSource) return;

    mainImage.src = imageSource;
    mainImage.alt = imageAlt;

    thumbnails.forEach((thumbnail, index) => {
      const active = index === currentIndex;
      thumbnail.classList.toggle('active', active);
      thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (lightboxImage) {
      lightboxImage.src = imageSource;
      lightboxImage.alt = imageAlt;
    }
    resetLightboxZoom();
  }

  function imagePath(source) {
    if (!source) return '';
    try {
      return new URL(source, window.location.href).pathname;
    } catch (error) {
      return source.split('?')[0];
    }
  }

  function showVariantImage({ imageId, imageSrc, imageAlt } = {}) {
    const matchingIndex = thumbnails.findIndex((thumbnail) => {
      const idMatches = imageId && thumbnail.dataset.imageId === String(imageId);
      const sourceMatches = imageSrc
        && imagePath(thumbnail.dataset.gallerySrc) === imagePath(imageSrc);
      return idMatches || sourceMatches;
    });

    if (matchingIndex >= 0) {
      showImage(matchingIndex);
      return;
    }

    if (!mainImage || !imageSrc) return;

    mainImage.src = imageSrc;
    mainImage.alt = imageAlt || '';
    thumbnails.forEach((thumbnail) => {
      thumbnail.classList.remove('active');
      thumbnail.setAttribute('aria-current', 'false');
    });

    if (lightboxImage) {
      lightboxImage.src = imageSrc;
      lightboxImage.alt = imageAlt || '';
    }
    resetLightboxZoom();
  }

  gallery.addEventListener('variant:image-change', (event) => {
    showVariantImage(event.detail);
  });

  showVariantImage({
    imageId: gallery.dataset.selectedVariantImageId,
    imageSrc: gallery.dataset.selectedVariantImageSrc,
    imageAlt: gallery.dataset.selectedVariantImageAlt
  });

  function openLightbox() {
    if (!lightbox || !mainImage) return;

    if (lightboxImage) {
      lightboxImage.src = mainImage.src;
      lightboxImage.alt = mainImage.alt;
    }

    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gallery-open');
    document.body.style.overflow = 'hidden';
    resetLightboxZoom();
  }

  function closeLightbox() {
    if (!lightbox) return;

    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gallery-open');
    document.body.style.overflow = '';
    resetLightboxZoom();
  }

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => showImage(index));
  });

  previousButton?.addEventListener('click', () => {
    showImage(currentIndex - 1);
  });

  nextButton?.addEventListener('click', () => {
    showImage(currentIndex + 1);
  });

  lightboxPreviousButton?.addEventListener('click', () => {
    showImage(currentIndex - 1);
  });

  lightboxNextButton?.addEventListener('click', () => {
    showImage(currentIndex + 1);
  });

  zoomButton?.addEventListener('click', openLightbox);
  closeButton?.addEventListener('click', closeLightbox);

  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) {
      closeLightbox();
    }
  });

  lightbox?.addEventListener('wheel', (event) => {
    if (!lightbox.classList.contains('open') || !lightboxImage) return;
    event.preventDefault();
    lightboxScale = Math.min(4, Math.max(1, lightboxScale + (event.deltaY < 0 ? 0.25 : -0.25)));
    if (lightboxScale === 1) {
      lightboxX = 0;
      lightboxY = 0;
    }
    applyLightboxTransform();
    lightboxImage.style.cursor = lightboxScale > 1 ? 'grab' : 'zoom-in';
  }, { passive: false });

  lightboxImage?.addEventListener('pointerdown', (event) => {
    if (lightboxScale <= 1) return;
    event.preventDefault();
    draggingLightbox = true;
    dragStartX = event.clientX;
    dragStartY = event.clientY;
    dragOriginX = lightboxX;
    dragOriginY = lightboxY;
    lightboxImage.setPointerCapture(event.pointerId);
    lightbox?.classList.add('is-dragging');
  });

  lightboxImage?.addEventListener('pointermove', (event) => {
    if (!draggingLightbox) return;
    lightboxX = dragOriginX + event.clientX - dragStartX;
    lightboxY = dragOriginY + event.clientY - dragStartY;
    applyLightboxTransform();
  });

  const stopLightboxDrag = (event) => {
    if (!draggingLightbox) return;
    draggingLightbox = false;
    lightbox?.classList.remove('is-dragging');
    if (event.pointerId !== undefined && lightboxImage?.hasPointerCapture(event.pointerId)) {
      lightboxImage.releasePointerCapture(event.pointerId);
    }
  };

  lightboxImage?.addEventListener('pointerup', stopLightboxDrag);
  lightboxImage?.addEventListener('pointercancel', stopLightboxDrag);

  if (stage && mainImage && lens && window.matchMedia('(hover: hover)').matches) {
    const hideLens = () => {
      lens.style.display = 'none';
    };
    mainImage.addEventListener('mouseenter', () => {
      lens.style.backgroundImage = `url("${mainImage.currentSrc || mainImage.src}")`;
      lens.style.display = 'block';
    });
    mainImage.addEventListener('mousemove', (event) => {
      const rect = mainImage.getBoundingClientRect();
      const x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
      const y = Math.max(0, Math.min(rect.height, event.clientY - rect.top));
      const zoom = 2.4;
      const lensWidth = lens.offsetWidth;
      const lensHeight = lens.offsetHeight;
      lens.style.left = `${event.clientX}px`;
      lens.style.top = `${event.clientY}px`;
      lens.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;
      lens.style.backgroundPosition = `${-(x * zoom - lensWidth / 2)}px ${-(y * zoom - lensHeight / 2)}px`;
    });
    mainImage.addEventListener('mouseleave', hideLens);
    mainImage.addEventListener('load', hideLens);
    window.addEventListener('scroll', hideLens, { passive: true });
  }

  document.addEventListener('keydown', (event) => {
    if (!lightbox?.classList.contains('open')) return;

    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showImage(currentIndex - 1);
    if (event.key === 'ArrowRight') showImage(currentIndex + 1);
  });
});

document.querySelectorAll('.collection-filter').forEach((filter) => {
  document.addEventListener('click', (event) => {
    if (filter.open && !filter.contains(event.target)) filter.removeAttribute('open');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  setCartDrawer(false);
  setSearchModal(false);
  document.querySelectorAll('.desktop-nav > .nav-item').forEach((navItem) => {
    navItem.dispatchEvent(new Event('navigation:close'));
  });
});
